import React, { useRef, useState, useEffect } from "react";
import ReactDOM from "react-dom";

const TR3DotMenu = ({ menuItems = [] }) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);
  const triggerRef = useRef(null);

  const handleClickOutside = (e) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(e.target) &&
      !triggerRef.current.contains(e.target)
    ) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    if (showMenu) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showMenu]);

  return (
    <>
      <button
        ref={triggerRef}
        onClick={() => setShowMenu((prev) => !prev)}
        style={{
          all: "unset",
          cursor: "pointer",
          padding: "0",
          borderRadius: "0.5rem",
          transition: "background 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#F3F4F6")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="5" r="2" fill="#6B7280" />
          <circle cx="12" cy="12" r="2" fill="#6B7280" />
          <circle cx="12" cy="19" r="2" fill="#6B7280" />
        </svg>
      </button>

 {showMenu &&
  ReactDOM.createPortal(
    <div
      ref={menuRef}
      style={{
        position: "absolute",
        top:
          triggerRef.current?.getBoundingClientRect().top +
          window.scrollY +
          8,
        left:
          triggerRef.current?.getBoundingClientRect().left +
          window.scrollX -
          100,
        background: "#fff",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: "0.5rem",
        zIndex: 900,
        padding: "0.5rem",
        minWidth: "1rem",
      }}
    >
      {menuItems.map(({ label, onMenuClick }, idx) => (
        <div
          key={idx}
          onClick={(e) => {
            onMenuClick?.(e);
            setShowMenu(false);
          }}
          style={{
            all: "unset",
            display: "block",
            maxWidth: "100%",
            padding: "0.5rem 1rem",
            cursor: "pointer",
            color: "#111827",
            borderRadius: "0.25rem",
            fontSize: "14px",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#F3F4F6")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.background = "transparent")
          }
        >
          {label}
        </div>
      ))}
    </div>,
    document.body
  )}

    </>
  );
};

export default TR3DotMenu;
